// extracted by mini-css-extract-plugin
export var promotionLink = "_w1-0";